import { useTacticHooks } from '@gettactic/hooks';
import { useQuery } from '@tanstack/react-query';

export const useExternalsQuery = (objectId: string, objectType?: string, type?: string) => {
  const { apiClient } = useTacticHooks();
  return useQuery(
    ['useExternalsQuery', apiClient.slug, objectId],
    async () => {
      const res = await apiClient.externals.getExternalIds(
        objectId,
        objectType,
        type
      );
      return res.result;
    },
    {
      cacheTime: 0
    }
  );
};
